import {ResolvedPos} from "prosemirror-model";

export const isPosInTable = ($pos: ResolvedPos): boolean => {
    for (let d = $pos.depth; d > 0; d--)
        if ($pos.node(d).type.spec.tableRole == 'row') return true;
    return false;
}